/**
 * Ops Estimate Pricing API — decision support (does not commit quote).
 */

import api from "@/shared/api";

/**
 * @param {{
 *   leadId: string,
 *   quoteId?: string|null,
 *   formSnapshot?: {
 *     from?: string,
 *     to?: string,
 *     serviceType?: string,
 *     items?: unknown,
 *     itemsList?: unknown,
 *     routeKm?: number,
 *     originDepotToPickupKm?: number,
 *     destDepotToDropKm?: number,
 *     collectionKm?: number,
 *     deliveryKm?: number,
 *   },
 *   tryAi?: boolean,
 *   forceRefresh?: boolean,
 * }} payload
 */
export async function estimatePricingFromLead(payload) {
  const response = await api.post("/pricing/ops/estimate-from-lead", payload);
  return response.data?.data ?? response.data;
}

/**
 * @param {{ leadId: string, sides?: ("pickup"|"delivery")[] }} payload
 */
export async function resolveLeadAddresses(payload) {
  const response = await api.post("/pricing/ops/resolve-lead-addresses", payload);
  return response.data?.data ?? response.data;
}

/**
 * @param {{
 *   leadId: string,
 *   selections: {
 *     pickup?: { candidate?: object, provinceCode?: string },
 *     delivery?: { candidate?: object, provinceCode?: string },
 *   },
 * }} payload
 */
export async function applyLeadAddressResolution(payload) {
  const response = await api.post(
    "/pricing/ops/apply-lead-address-resolution",
    payload
  );
  return response.data?.data ?? response.data;
}

/**
 * Suggest a missing directed shared-load tariff from the live card.
 */
export async function suggestSharedRouteTariff(payload) {
  const response = await api.post("/pricing/ops/shared-routes/suggest", payload);
  return response.data?.data ?? response.data;
}

/**
 * Create or re-enable a shared-load route on the live card.
 */
export async function createSharedRouteTariff(payload) {
  const response = await api.post("/pricing/ops/shared-routes", payload);
  return response.data?.data ?? response.data;
}
